import { Group, Loader, Stack } from '@mantine/core';
import type { CatalogRule } from '@repo/api-codegen';
import {
	apiGetIncludedFiltersQueryKey,
	useApiGetIncludedFilters,
	useApiSetIncludedFilters,
} from '@repo/api-codegen';
import {
	DEFAULT_FILTER_OPTIONS,
	FILTER_OPTIONS_DIVIDER,
} from '@repo/common/components/Filter';
import { Text, Title } from '@repo/foundations';
import { queryClient } from '../../../../../api';
import { FilterBlockController } from '../../../../../features/FilterBlock';
import { FILTER_OPTIONS_CONFIG } from '../../../../Filter/constants';

export function GleanPreferences() {
	const { data: includedFilters, isLoading: isLoadingIncluded } =
		useApiGetIncludedFilters({});
	const { mutate: setIncludedFilters } = useApiSetIncludedFilters({
		onSuccess: (_, variables) => {
			// Optimistic update - immediately update the cache
			queryClient.setQueryData(
				apiGetIncludedFiltersQueryKey({}),
				variables.body
			);
		},
	});

	const handleIncludedFiltersChange = (rule: CatalogRule) => {
		setIncludedFilters({
			body: rule,
		});
	};

	// Show loading state while data is being fetched
	if (isLoadingIncluded) {
		return (
			<Group position="center">
				<Loader />
			</Group>
		);
	}

	return (
		<Stack spacing="xl">
			{/* Included Filters Section */}
			<Stack spacing="md">
				<Stack spacing={0}>
					<Title size="md">Included filters</Title>
					<Text size="sm" color="text/secondary/default">
						Resources matching these filters will be included in the Glean push
					</Text>
				</Stack>
				<FilterBlockController
					initialRule={
						(includedFilters as CatalogRule) || {
							operator: 'and',
							operands: [],
						}
					}
					onRuleChange={handleIncludedFiltersChange}
					filterOptions={DEFAULT_FILTER_OPTIONS.map((option) =>
						option === FILTER_OPTIONS_DIVIDER
							? option
							: FILTER_OPTIONS_CONFIG[option]
					)}
					displayPreview={true}
					errorOnEmpty={false}
					ruleName="include"
				/>
			</Stack>
		</Stack>
	);
}
